<template>
  <div>
    <div id="app">
    <b-alert :show="isDevelopment()" variant="danger">
    Development System
    <span v-if="mailOverride!=null">
    , E-Mails werden umgeleitet zu {{mailOverride}}
    </span>
    </b-alert>
    <b-alert :show="isTesting()" variant="danger">
    Test System
    <span v-if="mailOverride!=null">
    , E-Mails werden umgeleitet zu {{mailOverride}}
    </span>
    </b-alert>
      <MainMenu ref="mainMenu" :user="user" />
      <div class="container">
      <transition name="none">
        <router-view @logged:in="onUpdate" @userchanged="userChanged"/>
      </transition>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'

export default {
  name: 'App',
  components: {
    MainMenu
  },
  methods: {
    logout: async function () {
      await this.$store.commit('setUser', null)
      this.onUpdate()
    },
    isDevelopment: function () {
      return window.location.host.startsWith('localhost')
    },
    isTesting: function () {
      return window.location.host.startsWith('cutterkollegen.multimedia') || window.location.host.startsWith('editoren.film-at')
    },
    userChanged: function (user) {
      if (user != null) {
        console.log('userchanged', user.id)
        this.$emit('userchanged', user)
        if (this.$store.state.auth.user.id === user.id) {
          this.$store.commit('setUser', user)
        }
      }
    },
    beforeMount () {
      this.user = this.$store.state.auth.user
    },
    onUpdate: function (value) {
      if (this.$refs.mainMenu) {
        this.$refs.mainMenu.forceRerender()
      }
    }
  },
  computed: {
    user: function () {
      return this.$store.state.auth.user
    },
    mailOverride: function () {
      return this.$store.state.auth.baseData ? this.$store.state.auth.baseData.mailOverride : false
    }
  },
  data () {
    return {
      timer: ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/main/vue/App.vue